<div class="internal-activations-paid-header-container">
    <div class="internal-activations-paid-header">
        <span class="tapestry-title title--lg">{{
            headerLabel | translate
        }}</span>
    </div>
</div>
<div
    class="internal-activations-paid-container"
    piTesting="internal-activations-paid"
>
    <div class="internal-activations-paid-card">
        <img [src]="imgSrc" class="card-image" [alt]="imgAlt" />
        <div
            class="tapestry-body body--lg bold"
            [innerHTML]="description"
        ></div>
        <div
            class="tapestry-body body--md subtitle"
            [innerHTML]="secondaryDescription"
        ></div>
        @if (isUpgradeAccountButtonVisible) {
            <tapestry-button
                [text]="upgradeAccountButtonText | translate | sentenceCase"
                (buttonClicked)="upgradeAccountClicked()"
                [size]="ButtonSize.Medium"
                [color]="ButtonColor.Primary"
                [disabled]="!isUpgradeAccountButtonEnabled"
            ></tapestry-button>
        }
        @if (additionalDetailsHtml) {
            <div
                [ngClass]="additionalDetailsClass"
                [innerHtml]="additionalDetailsHtml"
            ></div>
        }
    </div>
</div>
